export const DEFAULT_ADMIN_USERS = [
    {
        displayName: 'Parri Pandian',
        isAdmin: true,
        isEnabled: true,
        email: 'parri.vp@gmail.com'
    }
];
